import { FC, ReactNode } from "react";

import { PageGridHeaderRow } from "./PageGridHeaderRow";
import { PageRow } from "./PageRow";

import { type PageType, SectionKind } from "components/server-types";
import { ScrollableTableContainer } from "components/tables/ScrollableTableContainer";
import { AccordionTitle } from "mds/components/AccordionTitle";

export const PageAccordionSection: FC<{
  pages: PageType[];
  sectionKind?: SectionKind;
  title: ReactNode;
  startOpen?: boolean;
  onPageClick: (href: string) => void;
}> = ({ pages, sectionKind, title, startOpen = true, onPageClick }) => {
  if (!pages.length) {
    return null;
  }

  return (
    <AccordionTitle
      className="py-3"
      collapsedHeaderClassName="justify-between py-0 border-b border-black-tint-90"
      headerClassName="justify-between py-0"
      iconDirection="end"
      startOpen={startOpen}
      title={title}
    >
      <ScrollableTableContainer className="mb-0">
        <PageGridHeaderRow sectionKind={sectionKind} />

        <div role="rowgroup">
          {pages.map((page) => (
            <PageRow
              key={page.id}
              page={page}
              sectionKind={sectionKind}
              onPageClick={onPageClick}
            />
          ))}
        </div>
      </ScrollableTableContainer>
    </AccordionTitle>
  );
};
